import localePL from "./pl";
import localeGB from "./gb";

var localeRepo = {
  gb: {
    ...localeGB
  },
  pl: {
    ...localePL
  }
};

export default localeRepo;
